/*
 * @Author: Jiajia Li
 * @Date: 2024-08-27 17:13:09
 * @LastEditTime: 2024-08-30 08:57:53
 * @Description:
 */

import React from "react";
import ProductListWrapper from "../components/ProductListWrapper";

export default function ProductSearch() {
  return <ProductListWrapper title="Search Results" />;
}
